export enum SequenceStatus {
	NOT_PLAYED = 'NOT_PLAYED_TIEBREAKER_SEQUENCE_STATUS',
	PLAYED = 'PLAYED_TIEBREAKER_SEQUENCE_STATUS',
	IN_PROGRESS = 'IN_PROGRESS_TIEBREAKER_SEQUENCE_STATUS'
}

export interface TieBreakerSequence {
	uuid: string;
	matchUuid: string;
	teamOnePlayerOneUuid: string;
	teamOnePlayerOneName: string;
	teamOnePlayerTwoUuid: string | null;
	teamOnePlayerTwoName: string | null;
	teamTwoPlayerOneUuid: string;
	teamTwoPlayerOneName: string;
	teamTwoPlayerTwoUuid: string | null;
	teamTwoPlayerTwoName: string | null;
	teamOneScore: number;
	teamTwoScore: number;
	gameNumber: number;
	sequenceNumber: number;
	sequenceStatus: SequenceStatus;
	dateRecorded: string;
}

export interface TieBreakerSequenceResponse {
	results: {
		sequences: TieBreakerSequence[];
	};
}
